import Container from '@mui/material/Container';
import Page from 'components/system/Page';
import Typography from '@mui/material/Typography';
import colors from 'styles/colors';

const CompetitionsPageNotAllowed = () => (
  <Container>
    <Page
      title="Hackathons"
      withBackButton
      subTitle="Grow your data science skills by competing in our exciting Hackathons."
    >
      <Typography
        variant="h4"
        color={colors.text.secondary}
        sx={{
          textAlign: 'center',
          marginTop: '15%',
        }}
      >
        This page is not available in
        {' '}
        <Typography
          component="span"
          sx={{ font: 'inherit', fontWeight: 'bold' }}
          color={colors.text.primary}
        >
          Team Mode
        </Typography>
        .
        <br />
        Please switch off Team Mode to access it.
      </Typography>
    </Page>
  </Container>
);

export default CompetitionsPageNotAllowed;
